// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_7Zm","cls2":"BulkDownloadPing-cls2_QeZ BulkDownloadPing-cls1_7Zm"};